import { useQuery } from "@tanstack/react-query";
import { ToastService } from "@shared/lib/services";

import { BackednResponse } from "@shared/lib/types";
import { REPORTS_LIST_QUERY_KEY } from "../constants";

import { ReportService } from "../services/Report.servie";
import { IGetReports } from "@shared/lib/types/reports";

export function useGetReports(
  searchQuery?: string,
  limit?: number,
  pageNo?: number
) {
  const { data, isFetching, isError, error } = useQuery<
    BackednResponse<IGetReports>
  >({
    queryKey: [REPORTS_LIST_QUERY_KEY, searchQuery, limit, pageNo],
    queryFn: () => ReportService.getReports(searchQuery, limit, pageNo),
  });

  const errorMessage = isError && error?.message;

  if (errorMessage) {
    ToastService.error(errorMessage);
  }

  return {
    reports: data?.data,
    isFetching,
    isError,
  };
}
